import React, { useState, useContext, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
//import APIURL from "./Constants2";
import decode from "jwt-decode";
// import AuthHelperMethods from "./AuthHelperMethods";
import { MyContext, ListContext } from "./MyContext";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  StyledErrorMessage,
  OrangeButtonSm,
  PageTitle,
  HelpText,
  GreyText,
} from "./styleCustom";
const logoRed = require("/images/horseonlypng191.png").default;

import { ButtonOrange } from "./formComponents";

import { Logo } from "./images";

const APIURL = import.meta.env.VITE_DATA_API;
import Auth from "./Auth";

function LoginContainer({ children, label }) {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        justifyContent: "center",
        alignItems: "center",
        padding: "12 4 12 4",
        margin: 5,
      }}
    >
      <div
        style={{ width: "100%", maxWidth: 448 }}
        className="w-full max-w-md space-y-8"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10",
          }}
        >
          <Logo />
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            {label}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600"></p>
        </div>
        {children}
      </div>
    </div>
  );
}

function EmailInput({
  label,
  userName,
  placeholder = "Email address",
  setUserName = () => {},
}) {
  return (
    <div>
      <input
        type="username"
        value={userName}
        onChange={(e) => {
          setUserName(e.target.value);
        }}
        placeholder={placeholder}
        style={{
          width: "100%",
          border: "solid",
          borderColor: "#d1d5db",
          padding: 10,
          color: "#111827",
          borderRadius: 5,
          fontSize: 16,
          borderWidth: 1,
          marginBottom: 1,
        }}
      />
    </div>
  );
}

function PasswordInput({ password, setPassword = () => {} }) {
  return (
    <div>
      <label htmlFor="password" className="sr-only">
        Password
      </label>
      <input
        type="password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
        placeholder="Password"
        style={{
          width: "100%",
          border: "solid",
          borderColor: "#d1d5db",
          padding: 10,
          color: "#111827",
          borderRadius: 5,
          fontSize: 16,
          borderWidth: 1,
        }}
      />
    </div>
  );
}

function LoginButton({ handleClick = () => {}, buttonLabel = "Sign In" }) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        marginTop: 10,
      }}
    >
      <ButtonOrange onClick={(e) => handleClick(e)} label={buttonLabel} />
    </div>
  );
}
function Login(props) {
  const { mystate, dispatch } = useContext(MyContext);
  const { listState, dispatch2 } = useContext(ListContext);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isError, setIsError] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [usercode, setUserCode] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  let history = useHistory();
  console.log("do you come here often?");
  const getUserPrivs = async (role_id, user_code) => {
    let url =
      user_code == "ADM"
        ? "permissions/getPermissionCodes"
        : "role_permissions/getPermissionsforRole";
    let params = { role_id: role_id };
    const result = await Auth.api(url, "get", params);
  };

  const goToPage = () => {
    let token = Auth.getToken();
    if (!token) return; // Prevent decode on undefined/null

    let user_code = decode(token).user_type_code;
    let user_person_id = decode(token).user_person_id;

    if (user_code === "ADM") {
      console.log("ADM");
      history.push("/admin/daysheet");
    }
    if (user_code === "INS") {
      dispatch2(["LOGGED_IN_STAFF", user_person_id]);
      history.push(`/admin/staffhome/${user_person_id}/schedule`);
    }

    if (user_code === "STU") {
      history.push(`/admin/clienthome/${user_person_id}/account`);
    }

    if (user_code === "SPR") {
      history.push(`/admin/superuser`);
    }
  };

  const postLogin = async (e) => {
    e.preventDefault();

    dispatch({ type: "FETCH_INIT" });
    const user = { email: userName, password: password };

    try {
      const result = await axios.post(`${APIURL}authenticate`, user, {
        skipGlobalErrorHandler: true,
      });
      console.log(result.data);
      let token = result.data.auth_token;
      localStorage.setItem("auth_token", result.data.auth_token);
      setLoggedIn(true);
      //const { role_id, user_type_code, user_person_id, username } = decode(token);
      if (token) {
        let role_id = decode(token).role_id || null;
        let user_code = decode(token).user_type_code;
        let user_person_id = decode(token).user_person_id;
        let userName = decode(token).username;

        if (role_id) getUserPrivs(role_id, user_code);
        //  goToPage(user_code, user_person_id);
      }
    } catch (error) {
      if (!error.response) {
        setErrorMessage(
          "Unable to connect. This may be a network issue or the server may be temporarily unavailable. Please try again.",
        );
      } else if (error.response.status === 401) {
        const reason = error.response.data?.error?.user_authentication;

        if (reason === "account_inactive") {
          setErrorMessage(
            "Your account is inactive. Please contact your administrator.",
          );
          posthog?.capture("login_failed", { reason: "account_inactive" });
        } else {
          setErrorMessage("The username or password provided were incorrect.");
          posthog?.capture("login_failed", { reason: "invalid_credentials" });
        }
      } else if (error.response.status >= 500) {
        setErrorMessage(
          "Something went wrong on our end. Please try again shortly.",
        );
      } else {
        setErrorMessage("An unexpected error occurred. Please try again.");
        posthog?.captureException(error, { context: "login" }); // worth tracking
      }
      setIsError(true); // outside all conditions
      dispatch({ type: "FETCH_ERROR" });
    }
  };

  useEffect(() => {
    if (Auth.loggedIn()) {
      goToPage();
    } else {
      Auth.setToken("");
    }
  }, [isLoggedIn]);

  const reset = () => {
    //  localStorage.setItem("auth_token", "");
  };

  return (
    <>
      <LoginContainer label={"Sign into your account"}>
        <form>
          <div
            style={{
              boxShadow: " 0 1px 2px 0 rgb(0 0 0 / 0.05)",
              borderRadius: 10,
            }}
          >
            <EmailInput setUserName={setUserName} userName={userName} />
            <PasswordInput setPassword={setPassword} password={password} />
          </div>

          <div
            className="flex items-center justify-between"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="text-sm">
              <Link to={"/password"}>Change/Forgot Password</Link>
            </div>
          </div>
          {isError && <div style={{ color: "red" }}>{errorMessage}</div>}
          <LoginButton handleClick={postLogin} />
        </form>
      </LoginContainer>
    </>
  );
}

export const PasswordFromToken = ({ mode = "create" }) => {
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const location = useLocation();
  const history = useHistory();

  const last = location.pathname.lastIndexOf("/");
  const token = location.pathname.substring(last + 1);

  const isReset = mode === "reset";
  const apiEndpoint = isReset ? "passwords/reset" : "passwords/create";
  const label = isReset ? "Reset your password" : "Create new password";

  return (
    <LoginContainer label={label}>
      <Formik
        initialValues={{
          token,
          password: "",
          ...(isReset && { email: "" }),
        }}
        validationSchema={Yup.object().shape({
          ...(isReset && {
            email: Yup.string()
              .email("Invalid email address")
              .required("Email is required"),
          }),
          password: Yup.string()
            .required("No password provided.")
            .min(8, "Password is too short - should be 8 chars minimum.")
            .matches(
              /^(?=.*[0-9])(?=.*[a-z])/i,
              "Must contain at least one number and one letter",
            ),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          setIsError(false);
          try {
            await axios.post(`${APIURL}${apiEndpoint}`, values, {
              skipGlobalErrorHandler: true, // ← add this
            });
            setSubmitting(false);
            history.push("/login");
          } catch (e) {
            if (e.response?.status === 404) {
              setErrorMessage(
                "This link is invalid or has expired. Please request a new one.",
              );
            } else {
              setErrorMessage("Something went wrong. Please try again.");
            }
            setIsError(true);
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 30,
              }}
            >
              <PageTitle>{label}</PageTitle>

              {isReset && (
                <>
                  <GreyText>Email</GreyText>
                  <Field
                    name="email"
                    type="email"
                    placeholder="Your account email address"
                  />
                  <ErrorMessage name="email" component={StyledErrorMessage} />
                </>
              )}

              <GreyText>Password</GreyText>
              <HelpText>
                Must be minimum 8 characters and contain at least one letter and
                one number
              </HelpText>
              <Field
                name="password"
                type="password"
                placeholder="New password – minimum 8 characters"
              />
              <ErrorMessage name="password" component={StyledErrorMessage} />

              <OrangeButtonSm type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Saving…" : "Set password"}
              </OrangeButtonSm>

              {isError && <div style={{ color: "red" }}>{errorMessage}</div>}
            </div>
          </Form>
        )}
      </Formik>
    </LoginContainer>
  );
};

export const ChangePassword = () => {
  const { mystate, dispatch } = useContext(MyContext);
  const { listState, dispatch2 } = useContext(ListContext);
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isNetworkError, setIsNetworkError] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleChangePassword = async () => {
    setIsNetworkError(false);
    setEmailSent(false);
    setIsLoading(true);

    try {
      await axios.post(
        `${APIURL}passwords/forgot`,
        { email: userName },
        {
          skipGlobalErrorHandler: true, // ← add this
        },
      );
    } catch (e) {
      // Only a genuine network/server failure – not "user not found"
      setIsNetworkError(true);
    } finally {
      setIsLoading(false);
      // Always show success message to avoid revealing whether the email exists
      setEmailSent(true);
    }
  };

  return (
    <LoginContainer label={"Request a password change"}>
      <EmailInput setUserName={setUserName} userName={userName} />
      {isNetworkError && (
        <div style={{ color: "red" }}>
          Something went wrong. Please try again.
        </div>
      )}
      <LoginButton
        handleClick={handleChangePassword}
        buttonLabel={isLoading ? "Sending…" : "Send Request"}
        disabled={isLoading}
        placeholder={"Enter the email address associated with your account"}
      />
      {emailSent && !isNetworkError && (
        <div style={{ color: "blue" }}>
          If an account exists for that email, a reset link has been sent.
        </div>
      )}
    </LoginContainer>
  );
};

export function WaiverNewAccountRedirect() {
  return (
    <LoginContainer
      label={"Login instructions have been sent to your email address."}
    >
      <div></div>
    </LoginContainer>
  );
}

export default Login;
